export enum ReadmitChangeType {
    BirthDate,
    Gender,
    ApplicationCountry
}